import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Animated,
  Easing,
  Dimensions,
  Platform,
  View,
  Image,
  StyleSheet,
  StatusBar,
  ScrollView,
  Text,
  TouchableOpacity,
} from 'react-native';
import { SafeAreaInsetsContext } from 'react-native-safe-area-context';

import Languages from '../../constants/Languages';
import Colors from '../../constants/Colors';
import Layout from '../../constants/Layout';
import FilledButton from '../FilledButton';

class SelectLanguage extends Component {
  static propTypes = {
    checkedItem: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
    goNext: PropTypes.func.isRequired,
    goBack: PropTypes.func.isRequired,
    translation: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.animated1 = new Animated.Value(0); // 0-300
    this.animated2 = new Animated.Value(0); // 600-900
    this.animated3 = new Animated.Value(0); // 800-1100

    Animated.timing(this.animated1, {
      toValue: 1,
      duration: 300,
      easing: Easing.ease,
      useNativeDriver: false,
    }).start();

    Animated.timing(this.animated2, {
      toValue: 1,
      duration: 300,
      delay: 600,
      easing: Easing.ease,
      useNativeDriver: false,
    }).start();

    Animated.timing(this.animated3, {
      toValue: 1,
      duration: 300,
      delay: 800,
      easing: Easing.ease,
      useNativeDriver: false,
    }).start();
  }

  animated1 = null;
  animated2 = null;
  animated3 = null;

  render() {
    const { checkedItem, onChange, goNext, goBack, translation } = this.props;
    const introText = translation.registration_intro;
    const selectLanguage = translation.fragment_registration_language_textview_title;
    const next = translation.fragment_registration_language_button_next;

    const items = [];
    Languages.languages.forEach((lang, index) => {
      const onCheck = () => {
        onChange(index);
      };
      items.push(
        <TouchableOpacity
          key={lang.name}
          style={styles.languageItem}
          onPress={onCheck}
          testID={`language-${lang.name}`}
        >
          <Text style={styles.languageText}>{lang.label}</Text>
          {index === checkedItem ? (
            <View style={styles.circleOuter}>
              <View style={styles.circleInner} />
            </View>
          ) : null}
        </TouchableOpacity>
      );
    });

    const height = Dimensions.get('window').height;
    const halfHeight = Math.floor(height / 2);
    const topMargin = Platform.OS === 'web' ? 50 : 70;

    return (
      <SafeAreaInsetsContext.Consumer>
        {(insets) => {
          const startingPosition = halfHeight - insets.top;
          return (
            <View style={styles.container} testID="language">
              {Platform.OS === 'ios' && <StatusBar barStyle="light-content" />}
              <Animated.View
                style={{
                  position: 'absolute',
                  top: startingPosition,
                  height: 56,
                  width: 147,
                  resizeMode: 'contain',
                  transform: [
                    {
                      translateY: this.animated1.interpolate({
                        inputRange: [0, 1],
                        outputRange: [0, -(startingPosition - topMargin)],
                      }),
                    },
                    {
                      scaleX: this.animated1.interpolate({
                        inputRange: [0, 1],
                        outputRange: [1, 1.33],
                      }),
                    },
                    {
                      scaleY: this.animated1.interpolate({
                        inputRange: [0, 1],
                        outputRange: [1, 1.33],
                      }),
                    },
                  ],
                }}
              >
                <TouchableOpacity onPress={goBack}>
                  <Image
                    source={require('../../assets/images/plentiful_logo_and_label.png')}
                    resizeMode="cover"
                    style={{
                      height: 56,
                      width: 147,
                      resizeMode: 'contain',
                    }}
                  />
                </TouchableOpacity>
              </Animated.View>
              <View
                style={{
                  position: 'absolute',
                  top: insets.top + 150,
                  alignItems: 'center',
                }}
              >
                <Animated.View
                  style={{
                    width: 270,
                    opacity: this.animated2,
                  }}
                >
                  <Text style={styles.infoText}>{introText}</Text>
                </Animated.View>
                <Animated.View
                  style={{
                    width: '100%',
                    opacity: this.animated3,
                  }}
                >
                  <View style={styles.headingContainer}>
                    <Text testID={`select-language-text`} style={styles.headingText}>
                      {selectLanguage}
                    </Text>
                  </View>
                  <View style={styles.container}>
                    <ScrollView
                      style={{
                        height: height - insets.top - insets.bottom - 470,
                        maxHeight: Platform.OS === 'ios' ? 500 : 400,
                      }}
                      contentContainerStyle={styles.contentContainer}
                    >
                      {items}
                    </ScrollView>
                  </View>
                  <View style={styles.nextContainer}>
                    <View style={styles.nextButtonContainer}>
                      <FilledButton
                        onPress={goNext}
                        label={next}
                        color={Colors.white}
                        textColor={Colors.mediumBlue}
                        backgroundColor={Colors.white}
                        full
                      />
                    </View>
                  </View>
                </Animated.View>
              </View>
            </View>
          );
        }}
      </SafeAreaInsetsContext.Consumer>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: Colors.mediumBlue,
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  infoText: {
    fontFamily: 'roboto-regular',
    lineHeight: 24,
    fontSize: 16,
    color: Colors.white,
    textAlign: 'center',
  },
  languageItem: {
    display: 'flex',
    flexDirection: 'row',
    flex: 1,
    justifyContent: 'space-between',
    alignItems: 'center',
    height: 56,
    width: Dimensions.get('window').width - 32,
    maxWidth: 380,
    marginLeft: 16,
    marginRight: 16,
    borderBottomWidth: 1,
    borderBottomColor: Colors.lightBlue,
  },
  languageText: {
    fontFamily: 'roboto-regular',
    lineHeight: 56,
    fontSize: 16,
    flex: 8,
    color: Colors.white,
  },
  circleOuter: {
    borderWidth: 1,
    borderColor: Colors.white,
    width: 17,
    height: 17,
    borderRadius: 17 / 2,
    padding: 1,
    marginLeft: 10,
  },
  circleInner: {
    backgroundColor: Colors.white,
    width: 13,
    height: 13,
    borderRadius: 13 / 2,
  },
  headingContainer: {
    display: 'flex',
    flexDirection: 'row',
    height: 56,
    justifyContent: 'center',
    alignItems: 'center',
  },
  headingText: {
    fontSize: 20,
    color: Colors.white,
    fontFamily: 'roboto-regular',
  },
  contentContainer: {
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  welcomeContainer: {
    alignItems: 'center',
    backgroundColor: '#0F77BA',
  },
  welcomeImage: {
    height: 184,
    resizeMode: 'contain',
    marginTop: 3,
    marginLeft: -10,
  },
  nextContainer: {
    flex: 1,
    padding: 16,
    marginTop: 32,
    alignItems: 'center',
  },
  nextButtonContainer: {
    flex: 1,
    width: Dimensions.get('window').width - 32,
    maxWidth: 380,
  },
});

export default SelectLanguage;
